import LazyLoad from 'lazyload';
import Geolocalisation from './geolocalisation';

export default class Nav {
    constructor() {
        this.open();
        this.close();
        this.closeBtn();
        this.lazy();
        this.closeNews();

        new Geolocalisation();
    }

    open() {
        const burger = document.querySelector('header .burger');
    	if(burger){
            burger.addEventListener('click', () => {
                document.querySelector('nav').classList.toggle('open');
                document.querySelector('.nav-overlay').style.display = 'block';
                document.querySelector('.close-nav').style.display = 'block';

                if(window.innerWidth < 768){
                    burger.style.opacity = '0';
                }
            });
        }
    }

    close() {
        const overlay = document.querySelector('.nav-overlay');
    	if(overlay){
            overlay.addEventListener('click', () => {
                document.querySelector('nav').classList.remove('open');
                document.querySelector('.nav-overlay').style.display = 'none';
                document.querySelector('.close-nav').style.display = 'none';

                if(window.innerWidth < 768){
                    document.querySelector('header .burger').style.opacity = '1';
                }
            });
        }
    }

    closeBtn() {
        const btn = document.querySelector('.close-nav');
        if(btn){
            btn.addEventListener('click', () => {
                document.querySelector('nav').classList.remove('open');
                document.querySelector('.nav-overlay').style.display = 'none';
                document.querySelector('.close-nav').style.display = 'none';

                if(window.innerWidth < 768){
                    document.querySelector('header .burger').style.opacity = '1';
                }
            });
        }
    }

    lazy() {
        let images = document.querySelectorAll('.b-lazy');
        new LazyLoad(images, {
            root: null,
            rootMargin: '50px',
            threshold: 0
        });
    }

    closeNews() {
        const news_message = document.querySelector('aside.message-newsletter');
        if(news_message){
            news_message.querySelector('.close').addEventListener('click', function() {
                this.parentElement.classList.remove('open');
            });
        }
    }
}